import {useEffect, useRef} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {signInAndUp} from "supertokens-auth-react/recipe/thirdparty";
import * as m from "@/paraglide/messages";

export function AuthCallback() {
  const navigate = useNavigate();
  const {providerId} = useParams();
  // Ref to prevent double-execution in React StrictMode
  // The OAuth authorization code can only be consumed once, so we must
  // ensure signInAndUp() is only called once per callback
  const hasHandledCallback = useRef(false);

  useEffect(() => {
    async function handleCallback() {
      // Prevent double-execution (StrictMode runs effects twice)
      if (hasHandledCallback.current) {
        return;
      }
      hasHandledCallback.current = true;

      try {
        console.log(`Handling OAuth callback for provider: ${providerId}`);

        const response = await signInAndUp();

        if (response.status === "OK") {
          // Sign in successful
          navigate("/favorites", {replace: true});
        } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          // Handle specific error
          console.error("Sign in not allowed:", response);
          navigate("/auth?error=not_allowed", {replace: true});
        } else {
          // No email provided by OAuth provider
          navigate("/auth?error=no_email", {replace: true});
        }
      } catch (err) {
        console.error("OAuth callback error:", err);
        navigate("/auth?error=callback_failed", {replace: true});
      }
    }

    handleCallback();
  }, [navigate, providerId]);

  return (
    <div className="bg-background flex min-h-screen items-center justify-center">
      <div className="space-y-4 text-center">
        <div className="border-primary mx-auto h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
        <p className="text-muted-foreground">{m.auth_completing_signin()}</p>
      </div>
    </div>
  );
}
